export default __webpack_public_path__ + "static/media/faceActive.3e6cf0f6.png";